import { render } from "./TingimusedKinnitamata.vue?vue&type=template&id=1502edbc&scoped=true&ts=true"
import script from "./TingimusedKinnitamata.vue?vue&type=script&lang=ts"
export * from "./TingimusedKinnitamata.vue?vue&type=script&lang=ts"

import "./TingimusedKinnitamata.vue?vue&type=style&index=0&id=1502edbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1502edbc"]])

export default __exports__